import { FileText, Sparkles, Trash2, Upload } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { InsurancePolicy } from '../../../../models/insurancePolicy'

interface PolicyDocumentsProps {
  policy: InsurancePolicy
  onUploadPolicyDoc?: () => void
  onDeletePolicyDoc?: (attachmentId: string) => void
  onGenerateSummary?: () => void
}

export function PolicyDocuments({
  policy,
  onUploadPolicyDoc,
  onDeletePolicyDoc,
  onGenerateSummary,
}: PolicyDocumentsProps) {
  const attachments = policy.policyDocument?.attachments ?? []
  const hasDoc = attachments.length > 0

  return (
    <div className="flex flex-col gap-2">
      <span className="text-muted-foreground text-md font-semibold">Policy documents</span>
      {hasDoc ? (
        <div className="flex flex-col items-start">
          {attachments.map((attachment) => (
            <div key={attachment.id} className="flex min-w-0 items-center gap-1">
              <Button
                variant="link"
                // Only wraps on a narrow screen — a desktop row fits, and h-auto would reflow it.
                className="min-w-0 px-0 max-lg:h-auto max-lg:text-left max-lg:wrap-anywhere max-lg:whitespace-normal"
                href={attachment.file}
                target="_blank"
              >
                <FileText />
                {attachment.fileName || 'Policy document'}
              </Button>
              {onDeletePolicyDoc && (
                <Button
                  variant="ghost"
                  size="sm"
                  aria-label={`Delete ${attachment.fileName || 'policy document'}`}
                  onClick={() => onDeletePolicyDoc(attachment.id)}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              )}
            </div>
          ))}
        </div>
      ) : (
        <span className="text-muted-foreground text-md">No policy document</span>
      )}
      {(onUploadPolicyDoc || (onGenerateSummary && hasDoc)) && (
        <div className="flex flex-wrap items-center gap-2">
          {onUploadPolicyDoc && (
            <Button variant="outline" size="sm" onClick={onUploadPolicyDoc}>
              <Upload className="h-4 w-4" />
              Add policy document
            </Button>
          )}
          {onGenerateSummary && hasDoc && (
            <Button variant="outline" size="sm" onClick={onGenerateSummary}>
              <Sparkles className="h-4 w-4" />
              {policy.summary ? 'Regenerate AI summary' : 'Generate AI summary'}
            </Button>
          )}
        </div>
      )}
    </div>
  )
}
